export function kliknalPasujacyProduktWZastosowaniu() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest(
            '[data-ga-event-kliknal-pasujacy-produkt-w-zastosowaniu]'
        );
        if (!target) return;

        window.dataLayer = window.dataLayer || [];

        const productsType =
            target
                .closest('.section-box')
                ?.querySelector('.section-box__title')
                ?.textContent.trim() || '';

        const application =
            document.querySelector('#hero-title')?.textContent.trim() || '';

        const currentUrl = window.location.origin
            + window.location.pathname
            + window.location.search;


        const clickedProduct =
            target
                .querySelector('.product-card__title')
                ?.textContent.trim() || '';

        window.dataLayer.push({
            event: 'kliknal_pasujacy_produkt_w_zastosowaniu',
            products_type: productsType,
            application: application,
            application_url: currentUrl,
            clicked_product_code: clickedProduct,
        });
    });
}
